import(/* webpackMode: "eager" */ "/vercel/path0/src/components/restaurants/RestaurantComponent.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/seo/RankMathSchema.tsx")